import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const iconPlus = <FontAwesomeIcon icon={faPlus} color="#97ba36" size="sm" />;

export default iconPlus;
